import { nextPageRecoveryIdentity } from '../../lib/pageRecoveryIdentity'
import { isChunkLoadError, recoverFromChunkError } from '../../lib/chunkLoadRecovery'
import { Component, useRef } from 'react'
import { useLocation } from 'react-router-dom'

export class PageErrorBoundary extends Component {
  state = { failed: false }

  static getDerivedStateFromError() {
    return { failed: true }
  }

  componentDidUpdate(previousProps) {
    // Query navigation can recover an error, but must not remount healthy
    // children: Collection consumes add parameters while retaining its picker.
    if (this.state.failed && previousProps.resetKey !== this.props.resetKey) {
      this.setState({ failed: false })
    }
  }

  componentDidCatch(error, info) {
    console.error('Page render failed', error, info.componentStack)
    // A page file replaced by a deploy (#543): reload once rather than strand the tab.
    if (isChunkLoadError(error)) recoverFromChunkError(error)
  }

  render() {
    if (!this.state.failed) return this.props.children
    return (
      <section role="alert" className="mx-auto flex min-h-[50vh] max-w-lg flex-col items-center justify-center gap-4 px-6 text-center">
        <h1 className="text-xl font-semibold text-cream">Something went wrong</h1>
        <p className="text-sm text-cream/60">Please return home and try again.</p>
        <a href="/" className="flex min-h-11 items-center justify-center rounded-xl bg-gold px-6 py-3 font-semibold text-charcoal-900">Back home</a>
      </section>
    )
  }
}

export default function PageRecovery({ children }) {
  const location = useLocation()
  const identity = useRef(null)
  identity.current = nextPageRecoveryIdentity(identity.current, location)
  return <PageErrorBoundary key={identity.current.key} resetKey={location.key}>{children}</PageErrorBoundary>
}
